import {
    makeStyles,
    tokens,
    typographyStyles,
} from "@fluentui/react-components";

export const useStyle = makeStyles({
    container: {
        minWidth: "20.25rem",
        height: "100%",
        overflow: "hidden",
    },
    headerTitle: {
        ...typographyStyles.body1Stronger,
    },
    accordion: {
        flexGrow: 1,
        overflow: "auto",
    },
    accordionItem: {
        paddingLeft: "30px",
    },
    accordionHeader: {
        fontFamily: tokens.fontFamilyBase,
        fontSize: tokens.fontSizeBase200,
        fontStyle: "normal",
        fontWeight: tokens.fontWeightRegular,
        lineHeight: tokens.lineHeightBase200,
        textAlign: "center",
        color: tokens.colorNeutralForeground3,
    },
    accordionPanel: {
        margin: "0px 10px 10px 10px",
    },
    accordionValue: {
        fontWeight: tokens.fontWeightSemibold,
    },
});
